import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container';
import IconFooter from './IconFooter';
import logo from '../../assets/images/logos/logo_verde.svg'
import { faFacebookF, faInstagram,  faLinkedinIn, faYoutube  } from "@fortawesome/free-brands-svg-icons"
import { faMobileAlt  } from "@fortawesome/free-solid-svg-icons"


const year = new Date().getFullYear();

const footer = props => {
    const linkHereNow = props.i18n.language !== 'pt' ? '//www.hereandnow.agency/en' : '//www.hereandnow.agency/' ;
    return(
        <footer> 
            <span className="footer-shadow">
                <span className="footer-shape white-bg">
                <Container>
                    <Row>
                        <Col xs={12} lg={3} className="mb-5">
                            <Col xs={5} md={4} lg={6} className="p-0">
                                <Link to={props.t('routes:homepage.path')+'#top'}>
                                    <img src={logo} alt="logo Sysmatch" className="mb-4"/>
                                </Link>
                            </Col>
                            <ul>
                                <li><Link to='#' className="click green" onClick={() => props.modal('ims')} >{props.t('partials:link-labels.sgi-policy')}</Link></li>
                                <li><NavLink to={props.t('privacy.path')+'#top'} className="green">{props.t('partials:link-labels.privacy')}</NavLink></li>
                                <li><NavLink to={props.t('cookies.path')+'#top'} className="green">{props.t('partials:link-labels.cookies')}</NavLink></li>
                            </ul>
                            <Row>
                                <IconFooter 
                                    to="https://www.instagram.com/sysmatch/"
                                    icon={faInstagram}
                                />
                                <IconFooter 
                                    to="https://www.facebook.com/Sysmatch/"
                                    icon={faFacebookF}
                                />
                                <IconFooter 
                                    to="https://www.linkedin.com/company/sysmatch/"
                                    icon={faLinkedinIn}
                                />
                                <IconFooter 
                                    to="https://www.youtube.com/channel/UCusRuLSE5ZvwiXjDvK7YuWg"
                                    icon={faYoutube}
                                />
                                <IconFooter 
                                    to="tel:+351213304403"
                                    icon={faMobileAlt}
                                />
                            </Row>
                        </Col>
                        <Col xs={{span:12}} md={{span:6}} lg={{offset:1, span:4}}>
                            <h4 className="fw-700">{props.t('partials:link-menu.produts')}</h4>
                            <ul className="pr-lg-2">
                                <li><NavLink to={props.t('attendenceManagement.path')+'#top'} >{props.t('partials:link-labels.attendence-management')}</NavLink></li>  
                                <li><NavLink to={props.t('projectManagement.path')+'#top'} >{props.t('partials:link-labels.project-management')}</NavLink></li>  
                                <li><NavLink to={props.t('meetingRoom.path')+'#top'} >{props.t('partials:link-labels.meeting-room')}</NavLink></li>  
                                <li><NavLink to={props.t('shareholderMeeting.path')+'#top'} >{props.t('partials:link-labels.shareholder-meeting')}</NavLink></li>  
                                <li><NavLink to={props.t('creditManagement.path')+'#top'} >{props.t('partials:link-labels.credit-management')}</NavLink></li>  
                                <li><NavLink to={props.t('comercialPaper.path')+'#top'} >{props.t('partials:link-labels.comercial-paper')}</NavLink></li>  
                                <li><NavLink to={props.t('billingSoftware.path')+'#top'} >{props.t('partials:link-labels.billing-software')}</NavLink></li>  
                            </ul>
                        </Col>
                        <Col xs={{span:12}} md={{span:6}} lg={4}>
                            <h4 className="fw-700">{props.t('partials:link-menu.services')}</h4>
                            <ul>
                                <li><NavLink to={props.t('consulting.path')+'#top'} >{props.t('partials:link-labels.consulting')}</NavLink></li>
                                <li><NavLink to={props.t('development.path')+'#top'} >{props.t('partials:link-labels.development')}</NavLink></li>
                                <li><NavLink to={props.t('outsourcing.path')+'#top'} >{props.t('partials:link-labels.outsourcing')}</NavLink></li>
                                <li><NavLink to={props.t('quality.path')+'#top'} >{props.t('partials:link-labels.quality')}</NavLink></li>
                                <li><NavLink to={props.t('nearshoring.path')+'#top'} >{props.t('partials:link-labels.nearshoring')}</NavLink></li>
                                <br/>
                                <li><NavLink to={props.t('jobs.path')+'#top'} ><strong>{props.t('partials:link-labels.jobs')}</strong></NavLink></li>
                                <li><Link to='#' className="click" onClick={() => props.modal('project')} >{props.t('partials:link-labels.project-sheet')}</Link></li>
                            </ul>
                        </Col>
                    </Row>
                    <Row className="copy justify-content-center"> 
                        <p> Copyright &copy; {year} <span>&#x25cf;</span> {props.t('partials:copyright')} <Link target="_new" to={linkHereNow}>Here &amp; Now Agency</Link></p>
                    </Row>
                </Container>
                </span>
            </span>
        </footer> 
    )
}

export default withTranslation(['routes', 'partials'])(footer);

